<template>
  <v-container class="pa-0" :class="{ 'appbar-touchable': touchable }">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-badge
          :content="ticketNewCount"
          :value="ticketNewCount > 0"
          color="error"
          overlap
        >
          <v-btn
            style="width: auto; height: auto"
            icon
            :class="{ 'appbar-touchable__btn': touchable }"
            v-bind="attrs"
            v-on="on"
            @click="goTo('userSupport')"
          >
            <my-icon
              :name="touchable ? 'headset-icon' : 'support-icon'"
              :width="touchable ? 22 : 18"
              :height="touchable ? 22 : 18"
              :stroke="
                touchable
                  ? $vuetify.theme.isDark
                    ? '#fff'
                    : '#455A64'
                  : undefined
              "
              :fill="
                touchable
                  ? undefined
                  : $vuetify.theme.isDark
                    ? '#fff'
                    : '#000'
              "
              :cursor-pointer="true"
            />
          </v-btn>
        </v-badge>
      </template>
      <span>{{ $t("support") }}</span>
    </v-tooltip>
  </v-container>
</template>

<script>
import MyIcon from "@/views/dashboard/components/general/icon/MyIcon.vue";

export default {
  components: {
    MyIcon,
  },
  props: {
    touchable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ticketNewCount() {
      return Number(this.$store.state.ticketNewCount) || 0;
    },
    isSupportUser() {
      try {
        const rawToken = localStorage.getItem("token");
        if (!rawToken) return false;
        const tokenObj = JSON.parse(rawToken);
        return Number(tokenObj?.init?.appBarsOpacity?.abr) === 83;
      } catch (e) {
        return false;
      }
    },
  },
  mounted() {
    if (this.isSupportUser) {
      this.fetchTicketNewCount();
    }
  },
  methods: {
    goTo(to) {
      this.$router.push({ name: to }).catch(() => {});
    },
    fetchTicketNewCount() {
      this.$axios
        .get(this.$endpoint + "ticketing", {
          params: {
            page: 1,
            options: JSON.stringify({ page: 1, itemsPerPage: 1 }),
          },
        })
        .then((r) => {
          const summary = r.data.summary || (r.data.data && r.data.data.summary);
          if (!summary) return;
          const rawNew =
            summary.new != null
              ? summary.new
              : summary.new_count != null
                ? summary.new_count
                : summary.newCount;
          if (rawNew == null) return;
          this.$store.commit("SET_TICKET_NEW_COUNT", Number(rawNew) || 0);
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
::v-deep .v-badge__badge {
  right: 6px !important;
  top: -8px !important;
  font-size: 9px !important;
  height: 14px !important;
  min-width: 14px !important;
  width: auto;
  padding: 0 4px !important;
  line-height: 14px !important;
}

.appbar-touchable__btn {
  width: 40px !important;
  height: 40px !important;
  margin: 0 !important;
  border-radius: 8px !important;
}

.appbar-touchable__btn:active {
  background: rgba(69, 90, 100, 0.08) !important;
}

.appbar-touchable ::v-deep .v-badge__badge {
  right: 4px !important;
  top: -2px !important;
}
</style>
